import { Injectable } from '@angular/core';

export interface GtmData {
  [key: string]: any;
}

@Injectable()
export class GtmService {
  userId: string;

  constructor() {
    // Make sure the dataLayer property exists on the window object,
    // or we will not be able to communicate with GTM.
    if (!Object.hasOwnProperty.call(window, 'dataLayer')) {
      throw new Error('`window.dataLayer` is not defined.');
    }
  }

  public triggerPageView(page: string, pageName: string) {
    this.trigger('pagina-virtual', {
      page: page,
      pagename: pageName
    });
  }

  public triggerError(error: string) {
    this.trigger('evento-interactivo', {
      'evento-interactivo-categoria': 'Onboarding',
      'evento-interactivo-accion': 'Error',
      'evento-interactivo-etiqueta': error // detalle del error
    });
  }

  public triggerEvent(categoria: string, action: string, label: string) {
    this.trigger('evento-interactivo', {
      'evento-interactivo-categoria': categoria,
      'evento-interactivo-accion': action,
      'evento-interactivo-etiqueta': label
    });
  }

  private push(data: GtmData) {
    window['dataLayer'].push(data);
  }

  private trigger(event: string, data?: GtmData) {
    if (typeof this.userId === 'undefined') {
      this.push({
        event,
        ...data
      });
    } else {
      this.push({
        event,
        userID: this.userId,
        ...data
      });
    }
  }

  setUserId(cic: string) {
    this.userId = cic;
  }

  getUserId(): string {
    return this.userId;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/gtm/gtm.service.ts